module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms62e"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms62eIndex,
      "searchBoxAlias": "request-subrogate",
      "maxRowspan": _vm.maxRowspan.index,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.currentDtereq,
      "descCodempid": _vm.app.currentUser.username[_vm.app.nowLang],
      "currentNumseq": _vm.detail.seqno,
      "currentCodempid": _vm.codempid,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "postHrms62eSave": _vm.postHrms62eSave,
      "indexSelected": _vm.indexSelected,
      "arrCodleave": _vm.dropdowns.codleave,
      "entitlement": _vm.entitleFlagleave.entitlement,
      "enableFlagLeave": _vm.entitleFlagleave.enableflagleave,
      "worktime": _vm.worktime,
      "receivedHrms62eEntitlement": _vm.receivedHrms62eEntitlement,
      "receivedHrms62eWorktime": _vm.receivedHrms62eWorktime,
      "descCodapp": _vm.dash.descCodapp,
      "eventBtn": _vm.eventBtn,
      "receivedHrms62eCreate": _vm.receivedHrms62eCreate,
      "descCodempidQuery": _vm.descCodempidQuery,
      "searchIndex": _vm.searchIndex,
      "searchDetail": _vm.searchDetail,
      "popup": _vm.popup,
      "receivedHrms62ePopup": _vm.receivedHrms62ePopup,
      "receivedHrms62eIndex": _vm.receivedHrms62eIndex,
      "receivedHrms62eCodleave": _vm.receivedHrms62eCodleave,
      "detailDisp": _vm.detailDisp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e25bbc80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms62e/component.vue
// module id = 4000
// module chunks = 1